import { ViewTransitionsFeatureOptions } from '@angular/router';

/** Keep entry motion local to a successful login; all other routes retain their behavior. */
export const loginTransition: ViewTransitionsFeatureOptions = {
  skipInitialTransition: true,
  onViewTransitionCreated: ({ from, to, transition }) => {
    const enteringHome = from.firstChild?.routeConfig?.path === 'login'
      && to.firstChild?.routeConfig?.path === 'home';
    if (!enteringHome || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      transition.skipTransition();
    }
  },
};
